import styled from "styled-components";
import {SimpleMessageDialogSingleLineContentBox} from "./simple-message-dialog-single-line-content.box";

export const SimpleMessageDialogMultiLineContentBox = styled(SimpleMessageDialogSingleLineContentBox)`   
    text-align: justify;
    overflow-y: auto;
    max-height: 450px;
`